import { render, staticRenderFns } from "./EnterTerminationDetailsTenant.vue?vue&type=template&id=2a4a1006&scoped=true"
import script from "./EnterTerminationDetailsTenant.vue?vue&type=script&lang=js"
export * from "./EnterTerminationDetailsTenant.vue?vue&type=script&lang=js"
import style0 from "./EnterTerminationDetailsTenant.vue?vue&type=style&index=0&id=2a4a1006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4a1006",
  null
  
)

export default component.exports